<template>
  <div>
    <el-alert
     style="margin-top: 15px;"
     title="提示"
     description="这里请谨慎设置，热更新和整包更新只能选择其中一个"
     type="warning"
     show-icon>
    </el-alert>

    <el-form ref="form" :model="model" :rules="rules" label-width="150px" style="margin-top:20px;">

      <el-form-item class="formitems" label="更新方式">
        <el-radio v-model="model.update_mode" :label="0">js资源热更新</el-radio>
        <el-radio v-model="model.update_mode" :label="1">整包升级</el-radio>
      </el-form-item>

      <div v-show="!model.update_mode">
        <el-form-item class="formitems" label="版本号" prop="wgt.version">
          <el-input placeholder="wgt热更新版本号" v-model="model.wgt.version"></el-input>
        </el-form-item>
        <el-form-item class="formitems" label="wgt热更新资源包链接" prop="wgt.url">
          <p style="color: red;font-size: 12px;">* 请先填写版本号再上传文件，因为文件是根据版本号命名的</p>
          <div style="display: flex;justify-content: flex-start">
            <el-input placeholder="请输入wgt热更新资源包下载链接" v-model="model.wgt.url" style="width: 600px;margin-right: 10px;">
            </el-input>
            <upload-file accept=".wgt" :file-name="`${$config.app_name}.${model.wgt.version}`"
             @success="uploadWGTSuccess">
              <el-button type="primary">选择文件</el-button>
            </upload-file>
          </div>
        </el-form-item>

        <el-form-item class="formitems" label="是否静默更新">
          <el-switch
           v-model="model.wgt.silentUpdate"
           :active-value="true"
           :inactive-value="false">
          </el-switch>
          <span style="color: #999">不会提示并强制重启</span>
        </el-form-item>

        <el-form-item class="formitems" label="是否内部测试">
          <el-switch
           v-model="model.wgt.isTest"
           :active-value="true"
           :inactive-value="false">
          </el-switch>
        </el-form-item>

        <el-form-item class="formitems" label="强制更新">
          <el-switch
           v-model="model.wgt.forceUpdate"
           :active-value="true"
           :inactive-value="false">
          </el-switch>
        </el-form-item>

        <el-form-item v-if="model.wgt.isTest" class="formitems" label="内测手机号">
          <el-input v-model="model.wgt.testMobile" type="textarea" placeholder="请输入更新测试的手机号，多个以英文逗号间隔"></el-input>
        </el-form-item>

        <el-form-item class="formitems" label="热更新日志">
          <el-input type="textarea" placeholder="填写热更新日志" rows="3" style="width: 500px;"
           v-model="model.wgt.releasenote"></el-input>
        </el-form-item>
      </div>

      <div v-show="model.update_mode">
        <div style="display: flex;align-items: center;height: 30px;margin-bottom: 15px;">
          <img src="@/assets/img/icon_android.png" style="width: 30px;height: 30px;margin-right: 10px;">
          <span style="font-size: 24px;font-weight: bold;">Android</span>
        </div>
        <el-form-item class="formitems" label="版本号" prop="android.version">
          <el-input placeholder="请输入安卓apk版本号" v-model="model.android.version"></el-input>
        </el-form-item>
        <el-form-item class="formitems" label="下载链接" prop="android.url">
          <p style="color: red;font-size: 12px;">* 请先填写版本号再上传文件，因为文件是根据版本号命名的</p>
          <div style="display: flex">
            <el-input placeholder="请输入安卓apk下载链接" style="width: 600px;margin-right: 10px;" v-model="model.android.url">
            </el-input>
            <upload-file accept=".apk" new-name="limeiyi" :fileName="`${$config.app_name}.${model.android.version}`"
             @success="uploadAPKSuccess">
              <el-button type="primary">选择文件</el-button>
            </upload-file>
          </div>
        </el-form-item>
        <el-form-item class="formitems" label="更新日志">
          <el-input type="textarea" placeholder="填写更新日志" rows="3" style="width: 500px;"
           v-model="model.android.releasenote"></el-input>
        </el-form-item>
        <el-form-item class="formitems" label="更新提示">
          <el-switch
           v-model="model.android.notice"
           :active-value="true"
           :inactive-value="false">
          </el-switch>
        </el-form-item>
        <div style="display: flex;align-items: center;height: 30px;margin-bottom: 15px;">
          <img src="@/assets/img/icon_ios.png" style="width: 30px;height: 30px;margin-right: 10px;">
          <span style="font-size: 24px;font-weight: bold;">IOS</span>
        </div>
        <el-form-item class="formitems" label="版本号" prop="ios.version">
          <el-input placeholder="请输入ios app版本号" v-model="model.ios.version"></el-input>
        </el-form-item>
        <el-form-item class="formitems" label="下载链接" prop="ios.url">
          <el-input placeholder="请输入跳转app store的链接" style="width: 500px" v-model="model.ios.url"></el-input>
        </el-form-item>
        <el-form-item class="formitems" label="更新日志">
          <el-input type="textarea" placeholder="填写更新日志" rows="3" style="max-width: 500px;"
           v-model="model.ios.releasenote"></el-input>
        </el-form-item>
        <el-form-item class="formitems" label="更新提示">
          <el-switch
           v-model="model.ios.notice"
           :active-value="true"
           :inactive-value="false">
          </el-switch>
        </el-form-item>
      </div>

      <el-form-item class="formitems">
        <el-button type="primary" :loading="loading" @click="saveModel">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
/*
 * @params { update_mode } Number 更新方式： 1整包升级，0JS热更新
 * */
import UploadFile from '@/components/Upload/upload-file'

export default {
  name: 'AppUpdate',
  components: {
    UploadFile
  },
  data() {
    const checkAndroid = (rule, value, callback) => {
      if (this.model.update_mode && !value) {
        callback(new Error(rule.field === 'android.version' ? '请输入安卓apk版本号' : '请输入安卓apk下载链接'))
      } else {
        callback()
      }
    }
    const checkIos = (rule, value, callback) => {
      if (this.model.update_mode && !value) {
        callback(new Error(rule.field === 'ios.version' ? '请输入ios app版本号' : '请输入跳转app store的链接'))
      } else {
        callback()
      }
    }
    const checkWgt = (rule, value, callback) => {
      if (!this.model.update_mode && !value) {
        callback(new Error(rule.field === 'wgt.version' ? '请输入wgt热更新版本号' : '请输入wgt热更新资源包链接'))
      } else {
        callback()
      }
    }
    return {
      model: {
        android: {
          version: '',
          url: '',
          releasenote: '',
          notice: false
        },
        ios: {
          version: '',
          url: '',
          releasenote: '',
          notice: false
        },
        wgt: {
          version: '',
          url: '',
          releasenote: '',
          silentUpdate: false, // 是否静默更新
          isTest: false, // 是否为内测，true表示只有填了手机号的才能收到更新
          testMobile: ''
        },
        update_mode: 0
      },
      rules: {
        android: {
          version: [{ validator: checkAndroid, trigger: 'blur' }],
          url: [{ validator: checkAndroid, trigger: 'blur' }]
        },
        ios: {
          version: [{ validator: checkIos, trigger: 'blur' }],
          url: [{ validator: checkIos, trigger: 'blur' }]
        },
        wgt: {
          version: [{ validator: checkWgt, trigger: 'blur' }],
          url: [{ validator: checkWgt, trigger: 'blur' }]
        }
      },
      loading: false
    }
  },
  created() {
    this.getInfo()
    // this.$store.commit("updateIsIndexPage", true);
  },
  methods: {
    async getInfo() {
      const { data } = await this.$api.common.getVersion()
      this.model = { ...this.model, ...data.value }
    },
    async saveModel() {
      await this.$validate(this.$refs.form)
      this.doSave()
    },
    async doSave() {
      await this.$api.common.postVersion({ value: this.model })
      this.$message.success('保存成功')
      this.getInfo()
    },
    uploadWGTSuccess(res) {
      this.model.wgt.url = res
    },
    uploadAPKSuccess(res) {
      this.model.android.url = res
    }
  }
}
</script>

<style scoped>
</style>
